import { forwardRef } from "react";

import {
  INPUT_FIELD_SKELETON_CLASS_NAME,
  type TInputSkeletonProps,
} from "@/ui/components/primitives/Skeleton/Skeleton.config";
import {
  SkeletonBlock,
} from "@/ui/components/primitives/Skeleton/SkeletonBlock";
import { cn } from "@/ui/lib/utils";

export const InputFieldSkeleton = forwardRef<
  HTMLDivElement,
  TInputSkeletonProps
>(({ className, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    data-component="InputFieldSkeleton"
    aria-hidden="true"
    className={cn("w-full animate-pulse", className)}
  >
    <SkeletonBlock className={INPUT_FIELD_SKELETON_CLASS_NAME} />
  </div>
));

InputFieldSkeleton.displayName = "InputFieldSkeleton";
